import { APICore } from './apiCore'

const api = new APICore()

function getCategoriasPOI (params) {
  const baseUrl = '/categoriasPOI'
  return api.get(baseUrl, params)
}

function getCategoriaPOI (id) {
  const baseUrl = `/categoriasPOI/${id}`
  return api.get(baseUrl, {})
}

function addCategoriaPOI (params) {
  const baseUrl = '/categoriasPOI'
  return api.createWithFile(baseUrl, params)
}

function updateCategoriaPOI (params) {
  const baseUrl = '/categoriasPOI'
  return api.updateWithFile(baseUrl, params)
}

function deleteCategoriaPOI (params) {
  const baseUrl = '/categoriasPOI'
  return api.delete(baseUrl, params)
}

export { getCategoriasPOI, getCategoriaPOI, addCategoriaPOI, updateCategoriaPOI, deleteCategoriaPOI }
